// This code was brought in from marketing-hub as js files and is not currently
// type safe so leaving as js for now
import { HAS_WINDOW } from '@eventbrite/feature-detection';

const dummy =
    (type = '') =>
    (...args) => {
        console.log(`Dummy ${type}`, ...args);
    };

// Main function to load Intercom.
export function loadIntercom() {
    if (process.env.NODE_ENV !== 'production') {
        window.Intercom = dummy('intercom');
    } else if (!window.Intercom) {
        initializeIntercom();
    }
}

// Initializes Intercom by updating the app ID and custom launcher selector.
function initializeIntercom() {
    if (typeof window.Intercom === 'function') {
        window.Intercom('reattach_activator');
        window.Intercom('update', {
            app_id: 'xlku466w',
            custom_launcher_selector: '.help-launcher',
        });
    } else {
        createIntercomStub();
        loadIntercomScript();
    }
}

// Creates an Intercom stub function to queue up Intercom calls until the real Intercom script is loaded.
function createIntercomStub() {
    const intercomStub = function () {
        intercomStub.c(arguments);
    };
    intercomStub.q = [];
    intercomStub.c = function (args) {
        intercomStub.q.push(args);
    };
    window.Intercom = intercomStub;
}

// Loads the Intercom script asynchronously, and adds a load event listener to execute the script when the window loads.
function loadIntercomScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://widget.intercom.io/widget/xlku466w';

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    // Check if the window has already loaded, and call the appropriate event listener.
    if (isWindowLoaded()) {
        script.onload();
    } else if (window.attachEvent) {
        window.attachEvent('onload', script.onload);
    } else {
        window.addEventListener('load', script.onload, false);
    }
}

// Returns true if the window has already loaded, false otherwise.
function isWindowLoaded() {
    return (
        performance &&
        performance.getEntriesByType('navigation').every((e) => e.loadEventEnd)
    );
}

export function identifyIntercom() {
    const eventbriteUser = window.__SERVER_DATA__?.user;
    const intercomUserHash = eventbriteUser?.intercomUserHash;

    if (eventbriteUser && intercomUserHash) {
        window.Intercom('boot', {
            app_id: 'xlku466w',
            name: eventbriteUser.fullName,
            email: eventbriteUser.email,
            user_hash: intercomUserHash,
            user_type: 'manager',
            admin_email: eventbriteUser.email,
            eventbrite_username: eventbriteUser.fullName,
            eventbrite_organization_id:
                eventbriteUser.activeOrganization &&
                eventbriteUser.activeOrganization.id,
            creation_platform: 'eventbrite',
            utm_source: window.utm_source,
            utm_campaign: window.utm_campaign,
            utm_medium: window.utm_medium,
        });
    }
}

function checkForIntercom() {
    if (!HAS_WINDOW || !window.Intercom) {
        console.error(`Attempted to call Intercom but it is not instantiated!`);

        return false;
    }

    return !!window.Intercom;
}

export function trackIntercomEvent(message, object) {
    checkForIntercom() && window.Intercom('trackEvent', message, object);
}

export function intercomUpdate(params) {
    checkForIntercom() && window.Intercom('update', params);
}
